import { createContext, useContext, useState, useCallback } from "react";
import { useSecurityMaster } from "./SecurityMasterContext";
import { useMarketToggle } from "./MarketContext";
import { useAuth } from "./AuthNewContext";
import axios from "axios";
import { useRef } from "react";

const MarketIndicatorContext = createContext();
// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// 🔹 Simple delay helper
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const MarketIndicatorProvider = ({ children }) => {
  const [indicatorData, setIndicatorData] = useState(null);
  const [previousClose, setPreviousClose] = useState();
  const [latestNseData, setLatestNseData] = useState();
  const [maData, setMaData] = useState([]);
  const [availableCandles, setAvailableCandles] = useState(0);
  const [intradayData, setIntradayData] = useState("");
  const [quoteData, setQuoteData] = useState();
  const [indicesData, setIndicesData] = useState("");
  const [nseIndexData, setNseIndexData] = useState("");
  const [marketCapData, setMarketCapData] = useState("");
  const [marketCapBulkData, setMarketCapBulkData] = useState([]);
  const [trendingData, setTrendingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [peerData, setPeerData] = useState();
  const [previousCloses, setPreviousCloses] = useState([]);
  const [targetPrice, setTargetPrice] = useState("");
  const [prevCloseData, setPrevCloseData] = useState([]);
  const [statsData, setStatsData] = useState("");
  const [returnData, setReturnData] = useState("");
  const [stockName, setStockName] = useState();
  const [screener, setScreener] = useState("");
  const [globalQuote, setGlobalQuote] = useState("");
  const [bulkQuotes, setBulkQuotes] = useState([]);
  const [messages, setMessages] = useState([]);
  const [resistanceData, setResistanceData] = useState("");
  const [aiError, setAiError] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);

  const [screenerLoading, setScreenerLoading] = useState(false);

  //global crossover

  const [globalCrossover, setGlobalCrossover] = useState({});
  const [globalCrossoverLoading, setGlobalCrossoverLoading] = useState(false);
  const [globalCrossoverError, setGlobalCrossoverError] = useState(null);

  const [globalCrossoverDates, setGlobalCrossoverDates] = useState({});
  const [bulkError, setBulkError] = useState("");
  const { loadNifty50 } = useSecurityMaster();
  const lastPromptRef = useRef(null);
  const { market } = useMarketToggle();

  const isIndia = market === "india";
  const token = JSON.parse(localStorage.getItem("authUser"))?.token;

  //   const fetchIndicators = async (securityId, days = 100) => {
  //     if (!securityId) return;

  //     setLoading(true);
  //     try {
  //       const res = await axios.get(`${BASE_URL}/api/dhan-indicators`, {
  //         params: { securityId, days },
  //       });

  //       setIndicatorData(res.data);
  //       return res.data;
  //     } catch (e) {
  //       console.error("Indicator fetch failed", e.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const isValidSecurityId = (securityId) => {
    if (securityId == null) return false; // null or undefined
    if (Array.isArray(securityId)) return false; // []
    if (typeof securityId !== "number") return false;
    if (Number.isNaN(securityId)) return false;
    return true;
  };

  const getISTDateKey = () =>
    new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());

  const loadGlobalCrossover = useCallback(
    async (source = "NASDAQ100", { force = false } = {}) => {
      const today = getISTDateKey();

      // ✅ cached for this IST day → return immediately
      if (
        !force &&
        globalCrossover[source] &&
        globalCrossoverDates[source] === today
      ) {
        return globalCrossover[source];
      }

      try {
        setGlobalCrossoverLoading(true);
        setGlobalCrossoverError(null);

        const res = await axios.get(`${BASE_URL}/api/global/crossover`, {
          params: { source, refresh: force ? 1 : undefined },
        });

        setGlobalCrossover((prev) => ({ ...prev, [source]: res.data }));
        setGlobalCrossoverDates((prev) => ({ ...prev, [source]: today }));
        return res.data;
      } catch (err) {
        setGlobalCrossoverError(err?.response?.data?.message || err.message);
        return null;
      } finally {
        setGlobalCrossoverLoading(false);
      }
    },
    [globalCrossover, globalCrossoverDates],
  );

  const fetchIndicators = async (securityId, days = 300) => {
    console.log("🚀 fetchIndicators CALLED with:", securityId);

    if (!securityId) {
      console.error("❌ fetchIndicators received null securityId");
      return;
    }

    try {
      const res = await axios.post(`${BASE_URL}/api/dhan-indicators`, {
        securityId,
        days,
      });

      console.log("📊 historical API response:", res.data);

      setIndicatorData(res.data);
    } catch (err) {
      console.error(
        "🔥 fetchIndicators failed:",
        err.response?.data || err.message,
      );
    }
  };

  const getPrevClose = async (securityId) => {
    setLoading(true);
    console.log("Secuirty id fro previous close is", securityId);
    try {
      const response = await axios.post(`${BASE_URL}/api/dhan-raw-test`, {
        securityId,
      });
      setPreviousClose(response.data);
    } catch (err) {
      setLoading(false);
      console.log("Error is", err.message);
    }
  };
  // const getMarketQuote = async ({ securityId, symbol, userID }) => {
  //   console.log("secuirty id for market quote", securityId, symbol, userID);
  //   if (!isValidSecurityId(securityId)) {
  //     setError("Market Quote not found for this stock!");
  //     setQuoteData(null);
  //     return;
  //   }
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     // const response = await axios.post(`${BASE_URL}/api/market-quote`, {
  //     //   NSE_EQ: [securityId],
  //     // });
  //     const response = await axios.post(`${BASE_URL}/api/market-quote`, {
  //       NSE_EQ: [securityId],
  //       symbol: symbol,
  //       userID: userID,
  //     });
  //     setQuoteData(response?.data?.data?.NSE_EQ);
  //     console.log("quote data from context", response?.data?.data?.NSE_EQ);
  //     // } catch (err) {
  //     //   setLoading(false);
  //     //   console.error("❌ loadNifty50PrevClose error:", err);
  //     //   setError(err.message);
  //     // }
  //   } catch (err) {
  //     console.error("❌ Quote error FULL:", err.response || err);

  //     // 🔥 CASE 1: TRIAL LIMIT
  //     if (err.response?.status === 403) {
  //       return {
  //         success: false,
  //         type: "TRIAL_LIMIT",
  //         showModal: true,
  //       };
  //     }

  //     // 🔥 CASE 2: OTHER ERROR
  //     setError(err.message);

  //     return {
  //       success: false,
  //       type: "ERROR",
  //       message: err.message,
  //       showModal: false,
  //     };
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //bulk quotes
  // const getBulkQuotes = async (securityIds = []) => {
  //   if (!securityIds?.length) return [];
  //   console.log("securityIds", securityIds);

  //   setBulkLoading(true);
  //   setBulkError(null);

  //   try {
  //     const res = await axios.post(`${BASE_URL}/api/market-quote`, {
  //       NSE_EQ: securityIds,
  //     });

  //     const data = res?.data?.data?.NSE_EQ || [];
  //     console.log("data", res.data);

  //     setBulkQuotes(data);

  //     return data;
  //   } catch (err) {
  //     console.error("Bulk quote error:", err);
  //     setBulkError(err.message);
  //     return [];
  //   } finally {
  //     setBulkLoading(false);
  //   }
  // };
  const resetMarketData = () => {
    setIndicatorData(null);

    setIntradayData(null);

    setQuoteData(null);

    setPreviousClose(null);

    setReturnData(null);

    // setMaData([]);

    // setAvailableCandles([]);

    setTargetPrice(null);
  };
  const getMarketQuote = async ({ securityId, symbol, userID }) => {
    console.log("security id for market quote", securityId, symbol, userID);

    if (!isValidSecurityId(securityId)) {
      setError("Market Quote not found for this stock!");
      setQuoteData(null);
      return { success: false };
    }

    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${BASE_URL}/api/market-quote`, {
        NSE_EQ: [securityId],
        symbol,
        userID,
      });

      const marketData = response?.data?.data?.NSE_EQ || response?.data?.NSE_EQ;
      console.log("response fata for market quote", response.data);

      console.log("🔥 FINAL MARKET DATA:", marketData);

      setQuoteData(marketData);

      return {
        success: true,
        data: marketData,
      };
    } catch (err) {
      console.error("❌ Quote error FULL:", err.response || err);

      if (err.response?.status === 403) {
        return {
          success: false,
          type: "TRIAL_LIMIT",
          showModal: true,
        };
      }

      setError(err.message);

      return {
        success: false,
        type: "ERROR",
        message: err.message,
        showModal: false,
      };
    } finally {
      setLoading(false);
    }
  };
  const getBulkQuotes = async (securityIds = []) => {
    if (!securityIds?.length) return [];

    const validIds = securityIds.filter(Boolean);

    if (!validIds.length) return [];

    console.log("Valid securityIds:", validIds);

    setBulkLoading(true);
    setBulkError(null);

    try {
      const res = await axios.post(`${BASE_URL}/api/market-quote`, {
        NSE_EQ: validIds,
      });

      console.log("Full API response:", res.data);

      const data = res?.data?.data?.NSE_EQ || [];

      setBulkQuotes(data);

      return data;
    } catch (err) {
      console.error("Bulk quote error:", err.response?.data || err.message);

      setBulkError(
        err.response?.data?.error || err.message || "Something went wrong",
      );

      return [];
    } finally {
      setBulkLoading(false);
    }
  };
  const resetBulkQuotes = () => {
    setBulkQuotes("");
  };
  const getNseIndices = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/nse-indices`);
      setIndicesData(response.data);
    } catch (err) {
      setLoading(false);
      console.log("Error is:-", err.message);
    }
  };

  const getMarketIntraday = async (securityId) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/api/dhan-intraday`, {
        securityId,
      });
      setIntradayData(response.data);
    } catch (err) {
      console.log("Error is:-", err.message);
    }
  };
  const getNseIndexData = async (index) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/nse-stock-indices`, {
        params: { index },
      });
      setNseIndexData(response.data);
    } catch (err) {
      console.log("Error is :-", err.message);
    }
  };
  const getMarketCap = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/market-cap`, {
        params: { symbol },
      });
      setMarketCapData(response.data);
      console.log("Market Cap data is:-", marketCapData);
    } catch (err) {
      setLoading(false);
      console.log("Error is ", err.messgae);
    }
  };
  const getMostTrending = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/trending`);
      setTrendingData(response.data);
    } catch (err) {
      console.log("Error is:", err.message);
    }
  };
  const getPeerStock = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/stockdata`, {
        params: {
          symbol: symbol,
        },
      });
      setPeerData(response.data);
    } catch (err) {
      console.log("Error is:", err.message);
    }
  };
  const getPrevCloseBulk = async (securityIds = []) => {
    if (!Array.isArray(securityIds) || !securityIds.length) return;

    setLoading(true);
    setError(null);

    try {
      const requests = securityIds.map((id) =>
        axios.post(`${BASE_URL}/api/dhan-raw-test`, { securityId: id }),
      );

      const responses = await Promise.allSettled(requests);

      const result = {};
      responses.forEach((res, index) => {
        if (res.status === "fulfilled") {
          result[securityIds[index]] = res.value.data;
        }
      });

      setPreviousCloses(result);
    } catch (err) {
      setError(err.message || "Failed to fetch bulk previous close");
    } finally {
      setLoading(false);
    }
  };
  const getMarketCapForSymbols = async (symbols) => {
    if (!Array.isArray(symbols) || !symbols.length) return [];

    setLoading(true);

    try {
      const requests = symbols.map((s) =>
        axios.get(`${BASE_URL}/api/market-cap`, {
          params: { symbol: s },
        }),
      );

      const responses = await Promise.allSettled(requests);

      const result = responses
        .filter((r) => r.status === "fulfilled")
        .map((r) => r.value.data);

      setMarketCapBulkData(result);
      return result;
    } catch (err) {
      console.error("Market cap bulk error", err);
      return [];
    } finally {
      setLoading(false);
    }
  };
  //resitanve

  // const loadNifty50PrevClose = async () => {
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     // 1️⃣ Get NIFTY 50 symbols
  //     const nifty50 = await loadNifty50(); // [{ symbol, security_id }]

  //     if (!Array.isArray(nifty50) || !nifty50.length) {
  //       throw new Error("NIFTY50 list is empty");
  //     }

  //     // 2️⃣ Fetch prevClose in parallel
  //     const requests = nifty50.map((s) =>
  //       axios
  //         .post(`${BASE_URL}/api/dhan-raw-test`, {
  //           securityId: s.security_id,
  //         })
  //         .then((res) => ({
  //           symbol: s.symbol,
  //           prev_close: res.data?.prevClose,
  //         }))
  //     );

  //     const results = await Promise.allSettled(requests);

  //     // 3️⃣ Filter valid rows
  //     const validRows = results
  //       .filter(
  //         (r) =>
  //           r.status === "fulfilled" && typeof r.value?.prev_close === "number"
  //       )
  //       .map((r) => r.value);

  //     if (!validRows.length) {
  //       throw new Error("No valid prevClose data found");
  //     }

  //     // 5️⃣ Store in state (🔥 THIS IS WHAT YOU WANTED)
  //     setPrevCloseData(validRows);

  //     console.log(
  //       `✅ PrevClose loaded & stored for ${validRows.length} stocks`
  //     );
  //   } catch (err) {
  //     console.error("❌ Error loading prevClose:", err);
  //     setError(err.message || "Failed to load prevClose");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const loadNifty50PrevClose = async () => {
    setLoading(true);
    setError(null);

    try {
      // 1️⃣ Get NIFTY50 symbols + security_ids
      const nifty50 = await loadNifty50(); // [{ symbol, security_id }]

      if (!Array.isArray(nifty50) || nifty50.length === 0) {
        throw new Error("NIFTY50 list is empty");
      }

      const results = [];

      // 2️⃣ Sequential API calls with delay
      for (let i = 0; i < nifty50.length; i++) {
        const stock = nifty50[i];

        try {
          const res = await axios.post(`${BASE_URL}/api/dhan-raw-test`, {
            securityId: stock.security_id,
          });

          const prevClose = res.data?.prevClose;

          if (typeof prevClose === "number") {
            results.push({
              symbol: stock.symbol,
              prev_close: prevClose,
              updatedAt: new Date().toISOString(),
            });
          }
        } catch (err) {
          console.warn(`⚠️ PrevClose failed for ${stock.symbol}`, err.message);
        }

        // ⏱️ RATE LIMIT CONTROL
        await sleep(300); // ~3 requests / second (safe)
      }

      setPrevCloseData(results);

      return results; // ✅ allows direct usage
    } catch (err) {
      console.error("❌ loadNifty50PrevClose error:", err);
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const getTargetPrice = async (symbol, market) => {
    setLoading(true);
    console.log("Symbol received for target price context", symbol);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/target-price/${symbol}?market=${market}`,
      );
      console.log("Response is ", response.data);
      setTargetPrice(response.data);
    } catch (err) {
      setLoading(false);
      setError(err.message);
      console.log("Error for target price is :-", err.message);
    }
  };
  const resetTargetPrice = () => {
    setTargetPrice("");
  };
  const getStockStatistics = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/statistics/${symbol}?market=${market}`,
      );
      setStatsData(response.data);
      console.log("response from statistics", response?.data);
    } catch (err) {
      setLoading(false);
      setError(err.message);
    }
  };

  const getReturnData = async (securityId) => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/api/returns`, {
        securityId: securityId,
      });
      setReturnData(response.data);
    } catch (err) {
      setLoading(false);
      setError(err.message);
    }
  };
  const getNameBySymbol = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/stock/${symbol}`);
      setStockName(response.data);
    } catch (err) {
      setLoading(false);
      setError(err.message);
    }
  };
  const getScreenerData = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/market-screener`);
      setScreener(response.data);
    } catch (err) {
      setLoading(false);
      setError(err.message);
      console.log("Error is:-", err);
    }
  };

  const getMarketQuotesForSymbols = async (symbols = []) => {
    if (!Array.isArray(symbols) || symbols.length === 0) {
      return [];
    }

    try {
      console.log("📤 Sending symbols for bulk quote:", symbols);

      const response = await axios.post(`${BASE_URL}/api/market/quotes/bulk`, {
        symbols,
      });

      console.log("📥 Bulk quote response:", response.data);

      return response.data?.data || [];
    } catch (err) {
      console.error(
        "❌ Bulk market quote error:",
        err?.response?.data || err.message,
      );

      return [];
    }
  };
  // const getScreenerData = async (lists = null) => {
  //   try {
  //     setScreenerLoading(true);

  //     const listParam = Array.isArray(lists) ? lists.join(",") : lists;

  //     const { data } = await axios.get(`${BASE_URL}/api/market-screeners`, {
  //       params: listParam ? { list: listParam } : {},
  //     });

  //     const result = data?.data || {};
  //     console.log("data from screener", data);

  //     setScreener((prev) => ({
  //       ...prev,
  //       ...result,
  //     }));

  //     return result;
  //   } catch (err) {
  //     console.error("Screener error:", err?.response?.data || err.message);

  //     return {};
  //   } finally {
  //     setScreenerLoading(false);
  //   }
  // };

  const getGlobalQuote = async (symbol) => {
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/api/globalQuote`, {
        params: {
          ticker: symbol,
        },
      });
      setGlobalQuote(response.data);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  // const getScreenerData = async (lists = null) => {
  //   try {
  //     setScreenerLoading(true);

  //     // ==================================================
  //     // 1. Existing universal parameter handling
  //     // ==================================================

  //     const listParam = Array.isArray(lists) ? lists.join(",") : lists;

  //     // ==================================================
  //     // 2. Existing screener request
  //     // ==================================================

  //     const { data } = await axios.get(`${BASE_URL}/api/market-screeners`, {
  //       params: listParam ? { list: listParam } : {},
  //     });

  //     const result = data?.data || {};

  //     console.log("📊 Raw screener result:", result);

  //     // ==================================================
  //     // 3. SPECIAL HANDLING ONLY FOR TRENDING
  //     // ==================================================

  //     let finalResult = {
  //       ...result,
  //     };

  //     /*
  //      * Trending response currently looks like:
  //      *
  //      * trending: [
  //      *   "BTC-USD",
  //      *   "AVGO",
  //      *   "AMD",
  //      *   ...
  //      * ]
  //      *
  //      * Only process if trending actually exists.
  //      */

  //     if (Array.isArray(result?.trending) && result.trending.length > 0) {
  //       /*
  //        * Check if trending is still an array of ticker strings.
  //        *
  //        * This prevents calling bulk quotes again if backend
  //        * eventually starts returning quote objects directly.
  //        */
  //       const isTickerArray = typeof result.trending[0] === "string";

  //       if (isTickerArray) {
  //         console.log("🔥 Trending symbols received:", result.trending);

  //         // ==============================================
  //         // Send entire trending ticker array
  //         // ==============================================

  //         const trendingQuotes = await getMarketQuotesForSymbols(
  //           result.trending,
  //         );

  //         console.log("✅ Trending quotes received:", trendingQuotes);

  //         /*
  //          * Replace ONLY trending.
  //          *
  //          * day_gainers, day_losers, most_actives etc.
  //          * remain exactly as returned by screener API.
  //          */

  //         finalResult = {
  //           ...result,

  //           trending: trendingQuotes.length > 0 ? trendingQuotes : [],
  //         };
  //       }
  //     }

  //     // ==================================================
  //     // 4. Existing merge behavior
  //     // ==================================================

  //     setScreener((prev) => ({
  //       ...prev,
  //       ...finalResult,
  //     }));

  //     // ==================================================
  //     // 5. Return final processed result
  //     // ==================================================

  //     return finalResult;
  //   } catch (err) {
  //     console.error("Screener error:", err?.response?.data || err.message);

  //     return {};
  //   } finally {
  //     setScreenerLoading(false);
  //   }
  // };

  // const getGlobalQuote = async (symbol) => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`${BASE_URL}/api/globalQuote`, {
  //       params: {
  //         ticker: symbol,
  //       },
  //     });
  //     setGlobalQuote(response.data);
  //   } catch (err) {
  //     setError(err.message);
  //   } finally {
  //     setLoading(false); // ✅ ALWAYS RUNS
  //   }
  // };

  // const sendPrompt = async (prompt) => {
  //   if (!prompt || !prompt.trim()) return;

  //   setError(null);

  //   // 1️⃣ Add user message immediately
  //   setMessages((prev) => [...prev, { role: "user", text: prompt }]);

  //   setLoading(true);

  //   try {
  //     const { data } = await axios.post(
  //       "http://localhost:8000/api/generateAIRes",
  //       {
  //         prompt,
  //       },
  //     );

  //     // Backend decides success / failure
  //     if (!data.success) {
  //       throw new Error(data.message || "AI request failed");
  //     }

  //     // 2️⃣ Add AI response
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: data.data.response,
  //         usage: data.data.usage,
  //       },
  //     ]);
  //   } catch (err) {
  //     setError(err.message);

  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: err.message || "Something went wrong.",
  //         error: true,
  //       },
  //     ]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const sendPrompt = async (prompt) => {
  //   if (!prompt || !prompt.trim() || loading) return;

  //   lastPromptRef.current = prompt;

  //   setError(null);

  //   // 1️⃣ Add user message immediately
  //   setMessages((prev) => [...prev, { role: "user", text: prompt }]);
  //   setLoading(true);

  //   const MAX_RETRIES = 3;
  //   const BASE_DELAY = 800; // 0.8s
  //   const MAX_DELAY = 5000;

  //   let attempt = 0;

  //   try {
  //     while (attempt <= MAX_RETRIES) {
  //       try {
  //         const { data } = await axios.post(
  //           "http://localhost:8000/api/generateAIRes",
  //           { prompt },
  //           { timeout: 30000 }, // important for slow AI responses
  //         );

  //         if (!data.success) {
  //           throw new Error(data.message || "AI request failed");
  //         }

  //         // 2️⃣ Add AI response
  //         setMessages((prev) => [
  //           ...prev,
  //           {
  //             role: "ai",
  //             text: data.data.response,
  //             usage: data.data.usage,
  //           },
  //         ]);

  //         return; // ✅ SUCCESS → EXIT FUNCTION
  //       } catch (err) {
  //         const status = err?.response?.status;

  //         // Retry ONLY for 429 or 5xx
  //         if ((status === 429 || status >= 500) && attempt < MAX_RETRIES) {
  //           const delay = Math.min(
  //             BASE_DELAY * Math.pow(2, attempt) + Math.random() * 300,
  //             MAX_DELAY,
  //           );

  //           console.warn(
  //             `Retrying AI request in ${delay}ms (attempt ${attempt + 1})`,
  //           );

  //           await sleep(delay);
  //           attempt++;
  //           continue;
  //         }

  //         // Non-retryable error
  //         throw err;
  //       }
  //     }
  //   } catch (err) {
  //     const message =
  //       err?.response?.status === 429
  //         ? "AI is busy. You can retry in a moment."
  //         : "Something went wrong. You can retry.";

  //     setError(message);

  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: message,
  //         error: true,
  //         retryable: true, // ✅ IMPORTANT FLAG
  //       },
  //     ]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // const sendPrompt = async (prompt) => {
  //   if (!prompt || !prompt.trim()) return;
  //   setMessages((prev) => [...prev, { role: "user", text: prompt }]);

  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const { data } = await axios.post(
  //       "http://localhost:8000/api/generateAIRes",
  //       { prompt },
  //     );

  //     // ✅ Add AI response
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: data.data.response,
  //       },
  //     ]);
  //   } catch (err) {
  //     const message = err?.response?.data?.message || "AI failed to respond";

  //     // ✅ EVEN ON ERROR, add AI message
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: message,
  //         error: true,
  //       },
  //     ]);

  //     setError(message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  //Send Prompt working
  // const sendPrompt = async (prompt, options = {}) => {
  //   const { showUser = true } = options;

  //   if (!prompt || !prompt.trim()) return;

  //   setError(null);

  //   if (showUser) {
  //     setMessages((prev) => [...prev, { role: "user", text: prompt }]);
  //   }

  //   setLoading(true);

  //   try {
  //     const { data } = await axios.post(`${BASE_URL}/api/generateAIRes`, {
  //       prompt,
  //     });

  //     if (!data.success) {
  //       throw new Error(data.message || "AI request failed");
  //     }

  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: data.data.response,
  //         usage: data.data.usage,
  //       },
  //     ]);
  //   } catch (err) {
  //     setError(err.message);
  //     setMessages((prev) => [
  //       ...prev,
  //       {
  //         role: "ai",
  //         text: err.message || "Something went wrong.",
  //         error: true,
  //       },
  //     ]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //sma and ema

  const getSma = async (securityId, period = 300) => {
    if (!securityId) return;

    try {
      setLoading(true);
      setError(null);

      // const payload = {
      //   securityId,
      //   ...(period.length > 0 && { period }),
      // };

      const response = await axios.post(`${BASE_URL}/api/market-sma`, {
        securityId: securityId,
      });

      const data = response.data;
      console.log("data from sma", data);

      setMaData(data.movingAverages || []);

      setAvailableCandles(data.availableCandles || 0);
    } catch (err) {
      setError(err?.response?.data?.error || "Failed to fetch SMA / EMA data");
    } finally {
      setLoading(false);
    }
  };
  //latest nseData
  const getLatestNseData = async (index) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/nse-indices-data?index=${index}`,
      );
      setLatestNseData(response.data);
    } catch (err) {
      setError(err.message);
    }
  };
  //New sendPrompt for database
  const sendPrompt = async (prompt, options = {}) => {
    const {
      showUser = true,
      queryType = "GENERAL",
      symbol = null,
      stockContext = null,
    } = options;

    if (!prompt || !prompt.trim()) return;

    setError(null);

    // show user message only when needed
    // if (showUser) {
    //   setMessages((prev) => [...prev, { role: "user", text: prompt }]);
    // }
    if (showUser) {
      const match = prompt.match(/User Query:\s*(.*)$/s);
      const userText = match ? match[1].trim() : prompt.trim();

      setMessages((prev) => [...prev, { role: "user", text: userText }]);
    }

    setLoading(true);

    try {
      const { data } = await axios.post(`${BASE_URL}/api/generateAIRes`, {
        prompt,
        queryType,
        symbol,
        stockContext,
      });

      if (!data.success) {
        throw new Error(data.message || "AI request failed");
      }

      setMessages((prev) => [
        ...prev,
        {
          role: "ai",
          text: data.data.response,
          usage: data.data.usage,
        },
      ]);
    } catch (err) {
      setAiError(err.message);

      setMessages((prev) => [
        ...prev,
        {
          role: "ai",
          text: err.message || "Something went wrong.",
          error: true,
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  //global rsi and macd

  return (
    <MarketIndicatorContext.Provider
      value={{
        indicatorData,
        fetchIndicators,
        loading,
        getPrevClose,
        previousClose,
        quoteData,
        getMarketQuote,
        getMarketIntraday,
        intradayData,
        getNseIndices,
        indicesData,
        getNseIndexData,
        nseIndexData,
        getMarketCap,
        marketCapData,
        getMostTrending,
        trendingData,
        getPeerStock,
        peerData,
        getMarketCapForSymbols,
        marketCapBulkData,
        loadNifty50PrevClose,
        prevCloseData,
        getTargetPrice,
        targetPrice,
        getStockStatistics,
        statsData,
        getReturnData,
        returnData,
        getNameBySymbol,
        stockName,
        getScreenerData,
        screenerLoading,
        getGlobalQuote,
        globalQuote,
        screener,
        getLatestNseData,
        latestNseData,
        sendPrompt,
        messages,
        getSma,
        maData,
        availableCandles,
        error,
        aiError,
        getBulkQuotes,
        bulkError,
        bulkLoading,
        bulkQuotes,
        resetBulkQuotes,
        resetTargetPrice,
        resetMarketData,

        //global crossover
        globalCrossover,
        globalCrossoverLoading,
        globalCrossoverError,
        loadGlobalCrossover,
      }}
    >
      {children}
    </MarketIndicatorContext.Provider>
  );
};

export const useMarketIndicators = () => useContext(MarketIndicatorContext);
